function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M60 84V16A12 12 0 0172 4h72a12 12 0 0112 12v56a12 12 0 01-12 12h-4.48a13 13 0 01.47 3.48 12 12 0 11-24 0 13.64 13.64 0 01.49-3.5h-64.6a13 13 0 01.47 3.48 12 12 0 11-24 0 23.77 23.77 0 01.45-3.42v-.08H16a12 12 0 01-12-12V48l10-28h46M83.9 31.97l11.95 11.95"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M88 64h28a16 16 0 000-32H83.9M95.88 20L83.9 31.97"
});

var SvgReturnProduct = function SvgReturnProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 104",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgReturnProduct;